var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [showPopup, setShowPopup] = useState(false); // State for the popup
    useEffect(() => {
    }, [isAuthenticated]); // Log whenever isAuthenticated changes
    useEffect(() => {
        // Check local storage for user info on app initialization
        const storedUserInfo = localStorage.getItem('userInfo');
        if (storedUserInfo) {
            const userInfo = JSON.parse(storedUserInfo);
            setUserInfo(userInfo);
            setIsAuthenticated(true); // Set authenticated state to true
        }
    }, []);
    const fetchUserInfo = (onSuccess) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const accessToken = localStorage.getItem('access_token');
            if (!accessToken) {
                initiateLogin();
                return;
            }
            const response = yield axios.get('https://graph.microsoft.com/v1.0/me', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const userInfo = {
                name: response.data.displayName || '',
                email: response.data.mail || response.data.userPrincipalName || '',
                id: response.data.id,
                jobTitle: response.data.jobTitle
            };
            setUserInfo(userInfo);
            setIsAuthenticated(true);
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            onSuccess();
        }
        catch (error) {
            console.error('Error fetching user info:', error);
            // Check if the error is due to an expired access token
            if (error.response && error.response.status === 401) {
                console.error('Access token expired, attempting to refresh...');
                yield refreshAccessToken(); // Attempt to refresh the access token
                // After refreshing, try to fetch user info again
                yield fetchUserInfo(onSuccess);
            }
        }
    });
    const initiateLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        const clientId = '4e427b72-05a2-4186-a728-d6369e408a01'; // Your Azure AD Application (client) ID
        const tenantId = '30f52344-4663-4c2e-bab3-61bf24ebbed8'; // Your Azure AD Tenant ID
        const redirectUri = process.env.REACT_APP_REDIRECT_URI; // Your redirect URI
        const scope = 'openid profile email User.Read'; // Scopes you want to request
        const responseType = 'code'; // Use "code" for authorization code flow
        // Generate code verifier and code challenge
        const codeVerifier = generateCodeVerifier();
        const codeChallenge = yield generateCodeChallenge(codeVerifier);
        // Store the code verifier in local storage for later use
        localStorage.setItem('code_verifier', codeVerifier);
        // Construct the login URL
        const loginUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
        window.location.href = loginUrl; // Redirect to Azure AD login page
    });
    const exchangeCodeForToken = (code, setShowPopup) => __awaiter(void 0, void 0, void 0, function* () {
        const clientId = '4e427b72-05a2-4186-a728-d6369e408a01'; // Your Azure AD Application (client) ID
        const tenantId = '30f52344-4663-4c2e-bab3-61bf24ebbed8'; // Your Azure AD Tenant ID
        const redirectUri = process.env.REACT_APP_REDIRECT_URI; // Your redirect URI
        const tokenUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`; // Use tenant-specific endpoint
        const params = new URLSearchParams();
        params.append('client_id', clientId);
        params.append('code', code);
        params.append('redirect_uri', redirectUri);
        params.append('grant_type', 'authorization_code');
        // Retrieve the code verifier from local storage
        const codeVerifier = localStorage.getItem('code_verifier');
        if (codeVerifier) {
            params.append('code_verifier', codeVerifier);
        }
        else {
            console.error('No code verifier found in local storage.');
            throw new Error('Code verifier not found'); // Throw an error if code verifier is missing
        }
        try {
            const response = yield axios.post(tokenUrl, params.toString(), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response.status === 200) {
                const data = response.data;
                const accessToken = data.access_token;
                const refreshToken = data.refresh_token; // Get the refresh token
                // Store the access token and refresh token in local storage
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem('refresh_token', refreshToken); // Store the refresh token
                // Fetch user info after successful token exchange
                yield fetchUserInfo(() => {
                    // Redirect to chat page after fetching user info
                    window.location.href = '/';
                });
            }
            else {
                console.error('Error exchanging code for token:', response.status, response.statusText);
                throw new Error(`Error exchanging code for token: ${response.statusText}`); // Throw an error for non-200 responses
            }
        }
        catch (error) {
            console.error('Error during token exchange:', error);
            if (error.response) {
                console.error('Response data:', error.response.data); // Log the response data for more insight
            }
            setShowPopup(true); // Show the popup for manual input
            throw error; // Rethrow the error to be caught in the Callback component
        }
    });
    const refreshAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
            console.error('No refresh token found');
            initiateLogin(); // Redirect to login to obtain a new access token
            return;
        }
        const clientId = '4e427b72-05a2-4186-a728-d6369e408a01'; // Your Azure AD Application (client) ID
        const tenantId = '30f52344-4663-4c2e-bab3-61bf24ebbed8'; // Your Azure AD Tenant ID
        const tokenUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`; // Use tenant-specific endpoint
        const params = new URLSearchParams();
        params.append('client_id', clientId);
        params.append('grant_type', 'refresh_token');
        params.append('refresh_token', refreshToken);
        try {
            const response = yield axios.post(tokenUrl, params.toString(), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response.status === 200) {
                const data = response.data;
                const newAccessToken = data.access_token;
                // Store the new access token
                localStorage.setItem('access_token', newAccessToken);
            }
            else {
                console.error('Error refreshing access token:', response.status, response.statusText);
                initiateLogin(); // Redirect to login to obtain a new access token
            }
        }
        catch (error) {
            console.error('Error refreshing access token:', error);
            initiateLogin(); // Redirect to login to obtain a new access token
        }
    });
    const generateCodeVerifier = () => {
        const array = new Uint32Array(28);
        window.crypto.getRandomValues(array);
        return Array.from(array, dec => ('0' + dec.toString(16)).slice(-2)).join('');
    };
    const base64UrlEncode = (str) => {
        return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };
    const generateCodeChallenge = (codeVerifier) => __awaiter(void 0, void 0, void 0, function* () {
        const hashed = yield sha256(codeVerifier);
        const byteArray = new Uint8Array(hashed); // Convert ArrayBuffer to Uint8Array
        return base64UrlEncode(String.fromCharCode(...byteArray)); // Use Uint8Array here
    });
    const sha256 = (plain) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(plain);
        return window.crypto.subtle.digest('SHA-256', data);
    };
    return (_jsx(AuthContext.Provider, Object.assign({ value: {
            isAuthenticated,
            userInfo,
            initiateLogin,
            setUserInfo,
            setIsAuthenticated,
            showPopup,
            setShowPopup,
            fetchUserInfo,
            exchangeCodeForToken // Ensure this is included
        } }, { children: children })));
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
